// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Navbar from "../Navbar/index";
// import ComplimentaryTable from "./ComplimentaryTable";
// import "react-datepicker/dist/react-datepicker.css";
// import { useNavigate } from "react-router-dom";
// import CustomerHistory from "./CustomerHistory";
// import "../../scss/History/history.scss";
// import "../../scss/History/datepicker.scss";
// import Select from "react-select";
// import '../../scss/customtable.scss';
// import '../../scss/CustomerPortal.scss';
// import Footer from "../Footer";
// import DiscountOrderTable from "./DiscountOrderTable";
// import { toast } from "react-toastify";
// import { Modal } from "react-bootstrap";
// import OutletSearch from './../SelectSearch/OutletSearch';

// const customStyles = {
//   control: (base) => ({
//     ...base,
//     minHeight: "42px",
//     borderRadius: "8px",
//     boxShadow: "none",
//     borderColor: "#d1d5db",
//     "&:hover": {
//       borderColor: "#9ca3af",
//     },
//   }),
// };

// const discountSelectStyles = {
//   control: (base) => ({
//     ...base,
//     minHeight: "42px",
//     borderRadius: "8px",
//     boxShadow: "none",
//     borderColor: "#d1d5db",
//     "&:hover": {
//       borderColor: "#9ca3af",
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     zIndex: 9999,
//   }),
// };

// const CustomerPortal = () => {
//   let url = process.env.REACT_APP_BASE_URL;
//   const today = new Date().toLocaleDateString('en-CA');

//   const [discountTotal, setDiscountTotal] = useState("");
//   const [totalSum, setTotalSum] = useState("");
//   const [customerHistory, setCustomerHistory] = useState([]);
//   const [complimentary, setComplimentary] = useState([]);
//   const [complimentaryTotal, setTotal] = useState("");
//   const [startDate, setStartDate] = useState(today);
//   const [endDate, setEndDate] = useState(today);
//   const [token, setToken] = useState("");
//   const [selectedOutlet, setSelectedOutlet] = useState("");
//   const [inputChange, setInputChange] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [noDataMessage, setNoDataMessage] = useState("");
//   const [show, setShow] = useState(false);
//   const [showCustomerHistory, setShowCustomerHistory] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [guestName, setGuestName] = useState("");
//   const [guestID, setGuestID] = useState("");
//   const [panNo, setPanNo] = useState("");
//   const [customerList, setCustomerList] = useState([]);
//   const [byDiscount, setByDiscount] = useState(false);
//   const [discountError, setDiscountError] = useState(null);
//   const [discountLoading, setDiscountLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [discountList, setDiscountList] = useState([]);
//   const [selectedDiscount, setSelectedDiscount] = useState();
//   const [discountOrders, setDiscountOrders] = useState([]);

//   const customerOptions = customerList.map(c => ({
//     value: c.guest_id,
//     label: c.name
//   }));

//   let navigate = useNavigate();

//   useEffect(() => {
//     let tokenCheck = localStorage.getItem("token");
//     let typeCheck = localStorage.getItem("type")

//     if (tokenCheck === null && typeCheck === 'kitchen') {
//       navigate("/");
//     } else {
//       setToken(localStorage.getItem("token"));
//     }
//   }, [navigate]);

//   useEffect(() => {
//     if (!token || !selectedOutlet) return;

//     const fetchDiscountList = async () => {
//       try {
//         setDiscountLoading(true);
//         setDiscountError(null);

//         const response = await axios.post(`${url}/discount-list`, { token: token, outlet: selectedOutlet });

//         const data = response.data || { discounts: [] };

//         const options = data.discounts.map(d => ({
//           value: d,
//           label: d
//         }));

//         setDiscountList(options);
//       } catch (error) {
//         setDiscountError('Failed to fetch discount list');
//         console.error(error);
//       } finally {
//         setDiscountLoading(false);
//       }
//     };

//     fetchDiscountList();
//   }, [token, selectedOutlet, url]);

//   const handleDiscountChange = (selectedOption) => {
//     setSelectedDiscount(selectedOption);
//   };

//   const handleDiscountSearch = async () => {
//     if (!selectedDiscount) {
//       toast.info("Please select a discount type");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError(null);

//       const res = await axios.post(`${url}/discount-orders`, {
//         startDate: startDate,
//         endDate: endDate,
//         outlet: selectedOutlet,
//         discountName: selectedDiscount.value,
//         token: token
//       })

//       const data = res.data || [];
//       setDiscountOrders(data);
//     } catch (err) {
//       setError('Error fetching discount orders');
//       console.log(err);
//     } finally {
//       setLoading(false);
//     }
//   }

//   const handleAllDiscountSearch = async () => {
//     if (!selectedDiscount) {
//       toast.info("Please select a discount type");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError(null);

//       const res = await axios.post(`${url}/all-discount-orders`, {
//         outlet: selectedOutlet,
//         discountName: selectedDiscount.value,
//         token: token
//       })

//       const data = res.data || [];
//       setDiscountOrders(data);
//     } catch (err) {
//       setError('Error fetching discount orders');
//       console.log(err);
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     axios.post(`${url}/getcustomerlists`, {
//       token: token,
//       outlet: selectedOutlet
//     })
//       .then(response => {
//         const transformed = response.data.map(customer => ({
//           name: customer.name,
//           value: customer.guest_id,
//           guest_id: customer.guest_id
//         }));
//         setCustomerList(transformed);
//       })
//       .catch(error => {
//         console.log('Customer List', error);
//       });
//   }, [token, selectedOutlet, url]);

//   const showComplimentary = () => {
//     setErrorMessage("");
//     setNoDataMessage("");

//     axios
//       .post(`${url}/customersaleshistory`, {
//         start_date: startDate,
//         end_date: endDate,
//         uname: inputChange,
//         token: token,
//         Outlet_Name: selectedOutlet,
//       })
//       .then((response) => {
//         if (response.data.details.length === 0) {
//           setNoDataMessage("No data available for the provided customer name and date range.");
//           setShowCustomerHistory(false); // Hide the customer history table
//         } else {
//           setShowCustomerHistory(true); // Show the customer history table
//           setCustomerHistory(response.data.details);
//           setDiscountTotal(response.data.DiscountTotal);
//           setTotalSum(response.data.Total);
//         }
//       })
//       .catch(() => {
//         setShowCustomerHistory(false); // Hide the customer history table in case of an error
//         setNoDataMessage("No data available. Please check your input.");
//       });

//     // Show data for complimentary
//     axios
//       .post(`${url}/complimentary`, {
//         start_date: startDate,
//         end_date: endDate,
//         uname: inputChange,
//         token: token,
//         Outlet_Name: selectedOutlet,
//       })
//       .then((response) => {
//         // If no complimentary data is available, show "No data available"
//         if (response.data.details.length === 0) {
//           setShow(false); // Hide the complimentary table
//         } else {
//           setShow(true); // Show the complimentary table
//           setComplimentary(response.data.details);
//           setTotal(response.data.Total);
//         }
//       })
//       .catch(() => {
//         setShow(false);
//       });
//   };

//   const handleInputChange = (event) => {
//     setInputChange(event.target.value);
//   };

//   const handleKeyPress = (event) => {
//     if (event.key === "Enter") {
//       showComplimentary();
//     }
//   };

//   const handleCloseModal = () => setShowModal(false);

//   // const openModalToAddPan = (info) => {
//   //   setGuestName(info.GuestName);
//   //   setGuestID(info.guestID);
//   //   setPanNo("");
//   //   setShowModal(true);
//   // };

//   const handleDateChange = (e, type) => {
//     const value = e.target.value;
//     if (type === 'start') {
//       setStartDate(value);
//     } else {
//       setEndDate(value);
//     }
//   };

//   const handleAddPan = async () => {
//     if (!panNo) return toast.error("PAN number cannot be empty");

//     try {
//       await axios.post(`${url}/update_guest_pan`, {
//         guest_id: guestID,
//         guest_name: guestName,
//         guest_pan: panNo,
//         outlet: selectedOutlet,
//         token: token
//       });

//       toast.success("PAN updated successfully");
//       handleCloseModal();
//     } catch (error) {
//       toast.error("Failed to update PAN");
//       console.error(error);
//     }
//   };

//   // Switching modes clears out the other mode's leftover state/messages so
//   // stale errors or results don't linger when you flip the toggle.
//   // const handleModeChange = (nextByDiscount) => {
//   //   setByDiscount(nextByDiscount);
//   //   setErrorMessage("");
//   //   setNoDataMessage("");
//   // };

//   return (
//     <div className="main-container">
//       <Navbar />

//       <div className="max-w-5xl mx-auto w-full p-3 bg-white rounded-xl shadow-md border border-gray-100 space-y-5 my-3">
//         {/* Row 1 — always-on filters: date range + outlet */}
//         <div className="flex flex-wrap items-end justify-between">
//           <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
//             Start Date
//             <input
//               type="date"
//               className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
//               value={startDate}
//               onChange={(e) => handleDateChange(e, 'start')}
//             />
//           </label>

//           <div>
//             <OutletSearch
//               selectedOutlet={selectedOutlet}
//               setSelectedOutlet={setSelectedOutlet}
//               token={token}
//               compact
//             />
//           </div>

//           <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
//             End Date
//             <input
//               type="date"
//               className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
//               value={endDate}
//               onChange={(e) => handleDateChange(e, 'end')}
//             />
//           </label>
//         </div>

//         {/* Row 2 — mode toggle: search by customer vs search by discount */}
//         {/* <div className="flex items-center gap-3">
//           <span className="text-sm font-medium text-gray-700">Search by</span>
//           <div className="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-1">
//             <button
//               type="button"
//               onClick={() => handleModeChange(false)}
//               className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${!byDiscount
//                 ? "bg-purple-100 text-purple-800 shadow-sm"
//                 : "text-gray-500 hover:text-gray-700"
//                 }`}
//             >
//               Customer
//             </button>
//             <button
//               type="button"
//               onClick={() => handleModeChange(true)}
//               className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${byDiscount
//                 ? "bg-pink-100 text-pink-800 shadow-sm"
//                 : "text-gray-500 hover:text-gray-700"
//                 }`}
//             >
//               Discount
//             </button>
//           </div>
//         </div> */}

//         {/* Row 3 — single panel driven by byDiscount. Rendered once, not duplicated. */}
//         <div>
//           {byDiscount ? (
//             <div className="flex flex-col gap-3 max-w-sm">
//               <div className="flex flex-col gap-1">
//                 <label className="text-sm font-medium text-gray-700">
//                   Discount Name
//                 </label>

//                 {discountError ? (
//                   <div className="alert alert-danger text-sm my-2">
//                     Error fetching discount list
//                   </div>
//                 ) : discountLoading ? (
//                   <div className="flex justify-center my-2">
//                     <div className="spinner-border text-primary" role="status">
//                       <span className="visually-hidden">Loading...</span>
//                     </div>
//                   </div>
//                 ) : (
//                   <Select
//                     value={selectedDiscount}
//                     isSearchable
//                     placeholder="Select Discount Name"
//                     onChange={handleDiscountChange}
//                     options={discountList}
//                     styles={discountSelectStyles}
//                   />
//                 )}
//               </div>

//               <div className="flex gap-3">
//                 <button
//                   className="px-4 py-2 rounded-lg font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//                   onClick={handleDiscountSearch}
//                   disabled={loading || !selectedDiscount}
//                 >
//                   View
//                 </button>

//                 <button
//                   className="px-4 py-2 rounded-lg font-medium bg-pink-100 text-pink-800 hover:bg-pink-200 hover:shadow-md text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//                   onClick={handleAllDiscountSearch}
//                   disabled={loading || !selectedDiscount}
//                 >
//                   View All
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <div className="flex justify-between">
//               <div className="flex-1 flex items-center gap-2">
//                 <label className="text-sm font-medium text-gray-700">
//                   Customer
//                 </label>
//                 <input
//                   type="text"
//                   placeholder="Type name..."
//                   onChange={handleInputChange}
//                   value={inputChange}
//                   onKeyDown={handleKeyPress}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-400"
//                 />
//                 {errorMessage && (
//                   <p className="text-sm text-red-500 font-medium">{errorMessage}</p>
//                 )}
//               </div>

//               <div className="flex-1 flex justify-center">
//                 <button
//                   onClick={showComplimentary}
//                   disabled={loading}
//                   className="self-start px-4 py-2 rounded-lg font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//                 >
//                   {loading ? (
//                     <span className="flex items-center gap-2">
//                       <svg className="animate-spin h-3 w-3" viewBox="0 0 24 24" fill="none">
//                         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
//                       </svg>
//                       Loading...
//                     </span>
//                   ) : 'Show'}
//                 </button>
//               </div>

//               <div className="flex-1 flex justify-end">
//                 {/* <button
//                   className="px-3 py-2 rounded-lg font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 hover:shadow-md text-sm"
//                   onClick={() => navigate('/addloyalty')}
//                 >
//                   Customer Loyalty
//                 </button> */}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="bg-history">
//         {noDataMessage && <p className="no-data-message">{noDataMessage}</p>}
//         {errorMessage && <p className="error-message">{errorMessage}</p>}

//         {byDiscount ?
//           <div>
//             <DiscountOrderTable
//               discountOrders={discountOrders}
//               selectedOutlet={selectedOutlet}
//               token={token}
//               url={url}
//               loading={loading}
//               error={error}
//             />
//           </div> :
//           <div className={show ? "customer-complimentary-history" : "customer-history"}>
//             {showCustomerHistory && (
//               <CustomerHistory
//                 customerHistory={customerHistory}
//                 discountTotal={discountTotal}
//                 totalSum={totalSum}
//                 selectedOutlet={selectedOutlet}
//                 start={startDate}
//                 end={endDate}
//                 url={url}
//                 token={token}
//               />
//             )}

//             {show && (
//               <ComplimentaryTable
//                 complimentary={complimentary}
//                 complimentaryTotal={complimentaryTotal}
//                 start={startDate}
//                 end={endDate}
//                 url={url}
//                 token={token}
//               />
//             )}
//           </div>
//         }
//       </div>

//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         centered
//         size="md"
//       >
//         <Modal.Header closeButton className="border-0 pb-3">
//           <Modal.Title className="w-100 text-center fw-semibold">
//             Add PAN Number
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body className="px-4 pt-3">
//           <div className="mb-4">
//             <label className="form-label fw-medium text-muted">
//               Select Customer
//             </label>

//             <Select
//               options={customerOptions}
//               styles={customStyles}
//               placeholder="Search customer..."
//               className="react-select-container"
//               classNamePrefix="react-select"
//               onChange={(selected) => {
//                 setGuestID(selected?.value);
//                 setGuestName(selected?.label || "");
//               }}
//             />
//           </div>

//           <div className="mb-4">
//             <label className="form-label fw-medium text-muted">
//               PAN No
//             </label>

//             <input
//               type="text"
//               className="form-control shadow-sm"
//               placeholder="Enter PAN number"
//               value={panNo}
//               onChange={(e) => setPanNo(e.target.value)}
//             />
//           </div>
//         </Modal.Body>

//         <Modal.Footer className="border-0 px-4 pb-4 flex justify-center gap-2">
//           <button
//             className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-sm"
//             onClick={handleCloseModal}
//           >
//             Close
//           </button>

//           <button
//             className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 text-sm shadow"
//             onClick={handleAddPan}
//           >
//             Add PAN
//           </button>
//         </Modal.Footer>
//       </Modal>

//       <Footer />
//     </div>
//   );
// };

// export default CustomerPortal;




















import { useEffect, useState } from 'react'
import OutletSearch from '../SelectSearch/OutletSearch';
import { Modal } from 'react-bootstrap';
import Footer from '../Footer';
import { toast } from 'react-toastify';
import axios from 'axios';
import Select from 'react-select';
import CustomerHistory from './CustomerHistory';
import ComplimentaryTable from './ComplimentaryTable';
import Navbar from '../Navbar';
import ComplimentaryItemsTable from './ComplimentaryItemsTable';
import { useNavigate } from 'react-router-dom';

const CustomerPortal = () => {
  const url = process.env.REACT_APP_BASE_URL;
  const today = new Date().toLocaleDateString('en-CA');
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    history: null,
    complimentary: null,
    complimentaryItems: null,
  });
  const [customerList, setCustomerList] = useState([]);
  const [totalSum, setTotalSum] = useState("");
  const [customerHistory, setCustomerHistory] = useState([]);
  const [complimentary, setComplimentary] = useState([]);
  const [complimentaryTotal, setComplimentaryTotal] = useState("");
  const [discountTotal, setDiscountTotal] = useState("");

  const [inputChange, setInputChange] = useState("");

  const [complimentaryItems, setComplimentaryItems] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [guestName, setGuestName] = useState("");
  const [guestID, setGuestID] = useState("");
  const [panNo, setPanNo] = useState("");
  const [panLoading, setPanLoading] = useState(false);

  const customerOptions = customerList.map(c => ({
    value: c.guest_id,
    label: c.name
  }));

  const handleDateChange = (e, type) => {
    const value = e.target.value;
    if (type === 'start') {
      setStartDate(value);
    } else {
      setEndDate(value);
    }
  };

  useEffect(() => {
    const fetchCustomerList = async () => {
      try {
        const response = await axios.post(`${url}/getcustomerlists`, {
          token: token,
          outlet: selectedOutlet
        });
        const transformed = response.data.map(customer => ({
          name: customer.name,
          value: customer.guest_id,
          guest_id: customer.guest_id
        }));
        setCustomerList(transformed);
      } catch (error) {
        console.error('Customer List fetch error:', error);
      }
    };

    fetchCustomerList();
  }, [token, selectedOutlet, url]);

  const showComplimentary = async () => {
    setLoading(true);

    const newErrors = {
      history: null,
      complimentary: null,
      complimentaryItems: null,
    };

    setErrors(newErrors);

    setCustomerHistory([]);
    setDiscountTotal("");
    setTotalSum("");

    setComplimentary([]);
    setComplimentaryTotal("");

    setComplimentaryItems({});

    const payload = {
      start_date: startDate,
      end_date: endDate,
      uname: inputChange,
      token,
      Outlet_Name: selectedOutlet,
    };

    const complimentaryItemsPayload = {
      token,
      outlet_name: selectedOutlet,
      from_date: startDate,
      to_date: endDate,
    };

    if (inputChange.trim()) {
      complimentaryItemsPayload.guest_name = inputChange.trim();
    }

    try {
      const historyRes = await axios.post(
        `${url}/customersaleshistory`,
        payload
      );

      setCustomerHistory(historyRes?.data?.details || []);
      setDiscountTotal(historyRes?.data?.DiscountTotal || "");
      setTotalSum(historyRes?.data?.Total || "");
    } catch (error) {
      console.error("Customer history error:", error);
      newErrors.history =
        error?.response?.data?.error || error?.response?.data?.message || "Failed to load customer history";
    }

    try {
      const complimentaryRes = await axios.post(
        `${url}/complimentary`,
        payload
      );

      setComplimentary(complimentaryRes?.data?.details || []);
      setComplimentaryTotal(complimentaryRes?.data?.Total || "");
    } catch (error) {
      console.error("Complimentary list error:", error);
      newErrors.complimentary =
        error?.response?.data?.error || error?.response?.data?.message || "Failed to load complimentary list";
    }

    try {
      const complimentaryItemsRes = await axios.post(
        `${url}/get-complimentary-items`,
        complimentaryItemsPayload
      );

      setComplimentaryItems(complimentaryItemsRes?.data || {});
    } catch (error) {
      console.error("Complimentary items error:", error);
      newErrors.complimentaryItems =
        error?.response?.data?.error || error?.response?.data?.message || "Failed to load complimentary items";
    }

    setErrors(newErrors);
    setLoading(false);
  };

  const handleInputChange = (event) => {
    setInputChange(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      showComplimentary();
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setGuestName("");
    setGuestID("");
    setPanNo("");
  };

  // const openModalToAddPan = () => {
  //   setGuestName("");
  //   setGuestID("");
  //   setPanNo("");
  //   setShowModal(true);
  // };

  const handleAddPan = async () => {
    if (!panNo.trim()) return toast.error("PAN number cannot be empty");
    if (!guestID) return toast.error("Please select a customer");

    setPanLoading(true);
    try {
      await axios.post(`${url}/update_guest_pan`, {
        guest_id: guestID,
        guest_name: guestName,
        guest_pan: panNo,
        outlet: selectedOutlet,
        token: token
      });

      toast.success("PAN updated successfully");
      handleCloseModal();
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.response?.data?.message || "Failed to update PAN");
      console.error(error);
    } finally {
      setPanLoading(false);
    }
  };

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderColor: '#d1d5db',
      boxShadow: 'none',
      '&:hover': { borderColor: '#a78bfa' },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#7c3aed' : state.isFocused ? '#ede9fe' : 'white',
      color: state.isSelected ? 'white' : '#374151',
    }),
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className='flex-grow p-3'>
        {/* Filter Bar */}
        <div className="z-50 max-w-6xl mx-auto px-4 py-3 bg-white rounded shadow-md space-y-2.5 mb-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <label className="flex-1 flex justify-start items-center gap-2 text-sm font-medium text-gray-700">
              Start Date:
              <input
                type="date"
                className="border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400"
                value={startDate}
                onChange={(e) => handleDateChange(e, 'start')}
              />
            </label>

            <div className='flex-1 flex justify-center'>
              <OutletSearch
                selectedOutlet={selectedOutlet}
                setSelectedOutlet={setSelectedOutlet}
                token={token}
                compact
              />
            </div>

            <label className="flex-1 flex justify-end items-center gap-2 text-sm font-medium text-gray-700">
              End Date:
              <input
                type="date"
                className="border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400"
                value={endDate}
                onChange={(e) => handleDateChange(e, 'end')}
              />
            </label>
          </div>

          <div className="flex justify-between items-center gap-3">
            <div className="flex-1 flex items-center justify-start gap-2">
              <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
                Customer Name:
              </label>
              <input
                type="text"
                placeholder="Type name..."
                onChange={handleInputChange}
                value={inputChange}
                onKeyDown={handleKeyPress}
                className="w-60 px-2.5 py-2 border border-gray-300 rounded-lg shadow-sm text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
            </div>

            <div className="flex-1 flex justify-center">
              <button
                onClick={showComplimentary}
                disabled={loading}
                className="px-4 py-2 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <svg className="animate-spin h-3 w-3" viewBox="0 0 24 24" fill="none">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                    </svg>
                    Loading...
                  </span>
                ) : 'Show'}
              </button>
            </div>


            <div className='flex-1 flex justify-end'>
              {/* <button
                className="px-4 py-2 rounded-sm font-medium bg-slate-100 text-slate-800 hover:bg-slate-200 hover:shadow-md text-sm transition-all"
                onClick={openModalToAddPan}
              >
                Add PAN No?
              </button> */}

              <button
                className="px-3 py-2 rounded-md font-medium bg-cyan-50 text-cyan-700 hover:bg-cyan-100 hover:shadow-md text-sm"
                onClick={() => navigate('/messages/history')}
              >
                Customer Marketing
              </button>
            </div>
          </div>
        </div>

        {/* Tables — side by side, each w-1/2 */}
        <div className="px-8 mx-auto flex gap-4 w-full pb-6">
          <div className="w-[55%] min-w-0">
            <CustomerHistory
              customerHistory={customerHistory}
              discountTotal={discountTotal}
              totalSum={totalSum}
              selectedOutlet={selectedOutlet}
              url={url}
              token={token}
              loading={loading}
              error={errors.history}
              startDate={startDate}
              endDate={endDate}
            />
          </div>

          <div className="w-[45%] min-w-0">
            <ComplimentaryTable
              complimentary={complimentary}
              complimentaryTotal={complimentaryTotal}
              start={startDate}
              end={endDate}
              token={token}
              loading={loading}
              selectedOutlet={selectedOutlet}
              error={errors.complimentary}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </div>

        <div className="px-8 pb-6">
          <ComplimentaryItemsTable
            data={complimentaryItems}
            loading={loading}
            error={errors.complimentaryItems}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      </div >

      {/* Add PAN Modal */}
      < Modal show={showModal} onHide={handleCloseModal} centered size="md" >
        <Modal.Header closeButton className="border-0 pb-3">
          <Modal.Title className="w-100 text-center fw-semibold">
            Add PAN Number
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 pt-3 text-left">
          <div className="mb-4">
            <label className="form-label font-medium">
              Select Customer
            </label>
            <Select
              options={customerOptions}
              styles={customSelectStyles}
              placeholder="Search customer..."
              className="react-select-container"
              classNamePrefix="react-select"
              onChange={(selected) => {
                setGuestID(selected?.value || "");
                setGuestName(selected?.label || "");
              }}
            />
          </div>

          <div className="mb-4">
            <label className="form-label fony-medium">
              PAN No
            </label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter PAN number"
              value={panNo}
              onChange={(e) => setPanNo(e.target.value)}
            />
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0 px-4 pb-4 flex justify-center gap-2">
          <button
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-sm transition-colors"
            onClick={handleCloseModal}
            disabled={panLoading}
          >
            Close
          </button>
          <button
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 text-sm shadow disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            onClick={handleAddPan}
            disabled={panLoading}
          >
            {panLoading ? 'Saving...' : 'Add PAN'}
          </button>
        </Modal.Footer>
      </Modal >

      <Footer />
    </div >
  );
};

export default CustomerPortal;